import { IFontFamilies, IFontSizes } from "../theme.types";

export const fontSizes: IFontSizes = {
  large: 18,
  base: 16,
  small: 14,
  smallest: 12,
};

export const fontFamilies: IFontFamilies = {
  regular: "Open Sans Regular",
  semiBold: "Open Sans Semi Bold",
};
